import Reflux from "reflux";
import { singletonStore, singletonActions } from "logic/singleton";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import fetch from "logic/rest/FetchProvider";
import UserNotification from "util/UserNotification";
const urlPrefix = ApiRoutes.TelemetryApiController.setting().url;
export const TelemetrySettingsActions = singletonActions(
  "telemetry.settings.actions",
  () => Reflux.createActions({
    update: { asyncResult: true },
    get: { asyncResult: true }
  })
);
export const TelemetrySettingsStore = singletonStore(
  "telemetry.settings.store",
  () => Reflux.createStore({
    listenables: [TelemetrySettingsActions],
    telemetrySetting: void 0,
    getInitialState() {
      return {
        telemetrySetting: this.telemetrySetting
      };
    },
    init() {
      this.get();
    },
    get() {
      const promise = fetch("GET", this._url());
      promise.then((response) => {
        this.telemetrySetting = response;
        this.propagateChanges();
        return response;
      });
      TelemetrySettingsActions.get.promise(promise);
    },
    update(settings) {
      const promise = fetch("PUT", this._url(), settings);
      promise.then(
        (response) => {
          this.telemetrySetting = response;
          this.propagateChanges();
          return response;
        },
        (error) => {
          UserNotification.error(`Update failed: ${error}`, "Could not update telemetry settings.");
        }
      );
      TelemetrySettingsActions.update.promise(promise);
    },
    propagateChanges() {
      this.trigger(this.getState());
    },
    getState() {
      return {
        telemetrySetting: this.telemetrySetting
      };
    },
    _url() {
      return qualifyUrl(urlPrefix);
    }
  })
);
